export async function getBrandsIndicator() {
  return new Promise((resolve) => {
    const brands = 100;
    setTimeout(() => {
      resolve(brands);
    }, 1500);
  });
}
